import i18n from '../plugins/i18n'

export const getLegalDisclosureContent = (type: string):string => {
  const legalDisclosureFilename = process.env.VUE_APP_DSH_MODE ? `legalDisclosure${process.env.VUE_APP_DSH_MODE}` : 'legalDisclosure'
  return process.env[`VUE_APP_OVERWRITE_${type.toUpperCase()}`] || i18n.t(`${legalDisclosureFilename}.${type}`) as string
}
